import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {Marker, Tooltip} from "react-leaflet";
import t from "../../../languages/pl";
import { getAddress } from './../../../requests/mapRequests';

const CustomPin = ({position}) => {
    const [searchingStarted, setSearchingStarted] = useState(false);
    const [address, setAddress] = useState(null);

    useEffect(() => {
        setSearchingStarted(true);
        fetchAddress();
    }, []);

    const fetchAddress = () => {
        if(!searchingStarted)
            getAddress(position, (response) => {
                setAddress(response.data.adres);
            });
    };

    return (
        <React.Fragment>
            <Marker
                position={position}
            >
                <Tooltip
                    direction="top"
                    className="toyotaFont"
                >
                    {t.address}
                    <br />
                    {address ? address : "Szukam adresu..."}
                </Tooltip>
            </Marker>
        </React.Fragment>
    );
};

CustomPin.propTypes = {
    position: PropTypes.object
};

export default CustomPin;
